import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { sortAccessGroupOptions } from "shared/functions";

import CountBadgeWithTooltip from "../CountBadgeWithTooltip";
import { UserAccessGroupsProps } from "./types";

const UserAccessGroups = ({
    accessGroups,
    tooltipPlacement
}: UserAccessGroupsProps) => {
    const { gray700 } = colors;

    const isSingleAccessGroup = accessGroups.length === 1;

    return (
        <CountBadgeWithTooltip
            count={accessGroups.length}
            tooltip={
                <ul
                    css={css({
                        maxHeight: "240px",
                        minWidth: "236px",
                        overflowY: "auto",
                        marginRight: "-16px",
                        padding: isSingleAccessGroup ? "0" : "0 16px",

                        "& > li": {
                            listStyle: isSingleAccessGroup ? "none" : "revert"
                        },

                        "& > li + li": {
                            marginTop: "4px"
                        },

                        "&::-webkit-scrollbar-thumb": {
                            borderColor: gray700
                        }
                    })}
                >
                    {sortAccessGroupOptions(accessGroups).map(
                        ({ id, name }) => (
                            <li key={id}>{name}</li>
                        )
                    )}
                </ul>
            }
            tooltipPlacement={tooltipPlacement}
        />
    );
};

export default UserAccessGroups;
